var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRmPerformanceNew(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1003_307)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.03809 11.4439L18.9367 5.12305",
    stroke: "#1E1E1E",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.3389 4.14404L18.9373 5.12299L17.9704 7.72141",
    stroke: "#1E1E1E",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.5537 19.8553H16.5322V11.3953C16.5322 11.235 16.5959 11.0813 16.7092 10.968C16.8225 10.8547 16.9763 10.791 17.1365 10.791H18.9494C19.1096 10.791 19.2634 10.8547 19.3767 10.968C19.49 11.0813 19.5537 11.235 19.5537 11.3953V19.8553Z",
    stroke: "#1E1E1E",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5107 19.8554H10.4893V13.2083C10.4893 13.048 10.5529 12.8943 10.6663 12.781C10.7796 12.6677 10.9333 12.604 11.0935 12.604H12.9064C13.0667 12.604 13.2204 12.6677 13.3337 12.781C13.447 12.8943 13.5107 13.048 13.5107 13.2083V19.8554Z",
    stroke: "#1E1E1E",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.46772 19.8556H4.44629V15.0213C4.44629 14.861 4.50996 14.7073 4.62328 14.594C4.73661 14.4807 4.89031 14.417 5.05057 14.417H6.86343C7.0237 14.417 7.17741 14.4807 7.29072 14.594C7.40405 14.7073 7.46772 14.861 7.46772 15.0213V19.8556Z",
    stroke: "#1E1E1E",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1003_307"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(3 3)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRmPerformanceNew);
export default __webpack_public_path__ + "static/media/RMPerformanceNew.8b24fc0e7780d0f673d09caf737c30b5.svg";
export { ForwardRef as ReactComponent };